import * as React from "react";
import { Badge } from "./badge";

export function BadgeDemo() {
  return (
    <div className="flex flex-wrap gap-2">
      <Badge>Default</Badge>
      <Badge variant="neutral">Neutral</Badge>
    </div>
  );
}
